/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
export const onClientEntry = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.comfama.com/comfama-ui/icons/icons.css?v2';
  document.head.appendChild(link);

  // Protección para Hotjar - prevenir errores si no está cargado
  if (typeof window !== 'undefined' && !window.hj) {
    window.hj = function () {
      (window.hj.q = window.hj.q || []).push(arguments);
    };
    window.hj.q = [];
  }
};
